export const validateConfig = (config) => {
    const errors = {};

    // Chart type is required
    if (!config.chartType) {
        errors.chartType = 'Chart type is required';
    }

    const isHeatmap = config.chartType === 'heatmap';

    if (isHeatmap && config.series && config.series.length > 1) {
        errors.series = 'Heat maps support only a single series';
    }

    // Validate each series
    config.series?.forEach((series, index) => {
        const prefix = `series.${index}`;

        if (!series.serie?.property) {
            errors[`${prefix}.property`] = 'Value property is required';
        }

        if (!series.serie?.xAxisCategoryProperty) {
            errors[`${prefix}.xAxisCategoryProperty`] =
                'X-axis category is required';
        }

        if (isHeatmap && !series.serie?.yAxisCategoryProperty) {
            errors[`${prefix}.yAxisCategoryProperty`] =
                'Y-axis category is required';
        }

        if (!isHeatmap && !series.serie?.label) {
            errors[`${prefix}.label`] = 'Label is required';
        }
    });

    // Y-axis min/max validation
    if (config.yAxis?.min !== null && config.yAxis?.max !== null) {
        if (config.yAxis.min !== undefined && config.yAxis.max !== undefined) {
            if (config.yAxis.min >= config.yAxis.max) {
                errors['yAxis.minMax'] = 'Min must be less than max';
            }
        }
    }

    // Timeline-specific validation
    if (config.chartType === 'timeline') {
        if (!config.timelineDateProperty) {
            errors.timelineDateProperty =
                'Date property is required for timeline';
        }
        if (!config.timelineTitleProperty) {
            errors.timelineTitleProperty =
                'Title property is required for timeline';
        }
    }

    // Treemap-specific validation
    if (config.chartType === 'treemap') {
        if (!config.hierarchyLevels || config.hierarchyLevels.length === 0) {
            errors.hierarchyLevels = 'At least one hierarchy level is required';
        }
    }

    return errors;
};

export const hasValidationErrors = (errors) => {
    return Object.keys(errors).length > 0;
};

export const getFieldError = (errors, fieldPath) => {
    return errors[fieldPath] || null;
};

export const isFieldValid = (errors, fieldPath) => {
    return !errors[fieldPath];
};
